// components/GoalDropZone.js
import React from 'react';
import { useDrop } from 'react-dnd';
import { Card, Button, IconAdd16, IconDelete16, colors } from '@dhis2/ui';

const GoalDropZone = ({ onDrop, selectedGoal, goals, onClear }) => {
    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'GOAL',
        drop: (item) => onDrop(item.goal.id),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    const selectedGoalData = goals.find(g => g.id === selectedGoal);

    return (
        <div
            ref={drop}
            style={{
                backgroundColor: isOver ? '#e6f7ff' : '#f8f9fa',
                border: `2px dashed ${isOver ? colors.blue700 : colors.grey400}`,
                borderRadius: '8px',
                padding: '16px',
                minHeight: '120px',
                transition: 'all 0.2s ease',
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h4 style={{ margin: 0, color: colors.blue700 }}>
                    📋 Linked Goal
                </h4>
                {selectedGoal && (
                    <Button
                        small
                        destructive
                        icon={<IconDelete16 />}
                        onClick={onClear}
                        title="Remove linked goal"
                    >
                        Clear
                    </Button>
                )}
            </div>
            
            {!selectedGoal ? (
                <div style={{ 
                    textAlign: 'center', 
                    color: colors.grey700,
                    padding: '20px'
                }}>
                    <IconAdd16 size={24} style={{ marginBottom: '8px' }} />
                    <p>Drag a goal here or click the card to select</p>
                    <p style={{ fontSize: '0.8rem', color: colors.grey600, marginTop: '4px' }}>
                        One or many objectives can be linked to one company goal
                    </p>
                </div>
            ) : selectedGoalData ? (
                <div style={{ 
                    backgroundColor: colors.blue050,
                    border: `1px solid ${colors.blue200}`,
                    borderRadius: '8px',
                    padding: '12px'
                }}>
                    <h5 style={{ margin: '0 0 8px 0', color: colors.blue700 }}>
                        ✅ {selectedGoalData.name}
                    </h5>
                    <p style={{ 
                        margin: '0 0 8px 0', 
                        fontSize: '0.8rem',
                        color: colors.grey700
                    }}>
                        {selectedGoalData.description}
                    </p>
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between',
                        fontSize: '0.75rem',
                        color: colors.grey600
                    }}>
                        <span>Progress: {selectedGoalData.progress}%</span>
                        <span>Status: {selectedGoalData.status}</span>
                    </div>
                </div>
            ) : (
                <div style={{ 
                    padding: '12px',
                    backgroundColor: colors.yellow050,
                    border: `1px solid ${colors.yellow300}`,
                    borderRadius: '4px',
                    color: colors.yellow800
                }}>
                    Goal data not available
                </div>
            )}
        </div>
    );
};

export default GoalDropZone;